module.exports = require("cli-table2");


//////////////////
// WEBPACK FOOTER
// external "cli-table2"
// module id = 28
// module chunks = 0